export default {"src":"/_next/static/media/fast_match_stakes_deselect_button.8c5bc560.svg","height":2,"width":8,"blurWidth":0,"blurHeight":0};